import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import PrimaryButton from './PrimaryButton';
import theme from './theme';

/**
 * Emotion style classes
 */
const padding = '0.5em';

const cardBox = css`
  background-color: ${theme.color.primary};
  box-shadow: 0 3px 12px ${theme.color.shadow};
  color: white;
  padding: 1em ${padding};
`;

const textSpace = css`
  padding-left: ${padding};
`;

/**
 * Components
 */
const CardSmall = ({ text, iconName, showPopupCard, dataPopupCard }) => (
  <div className="column is-half">
    <div className={cardBox}>
      <div className="columns is-gapless is-mobile is-vcentered">
        <div className="column is-narrow">
          <span className="icon is-large">
            <i className={`fa fa-${iconName} fa-3x`} />
          </span>
        </div>
        <div className="column">
          <span className={`is-size-5 is-uppercase ${textSpace}`}>{text}</span>
        </div>
        <div className="column is-narrow">
          <PrimaryButton handleClick={() => showPopupCard(dataPopupCard)} />
        </div>
      </div>
    </div>
  </div>
);

CardSmall.propTypes = {
  /** FontAwesome icon name (ex. 'plus-square') */
  iconName: PropTypes.string.isRequired,
  dataPopupCard: PropTypes.shape({
    body: PropTypes.node,
    title: PropTypes.string,
  }).isRequired,
  showPopupCard: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default CardSmall;
